import { createFileRoute, redirect } from '@tanstack/react-router';

/** `/plataforma` abre nas academias (spec 014). */
export const Route = createFileRoute('/_autenticado/plataforma/')({
  beforeLoad: () => {
    throw redirect({ to: '/plataforma/empresas', replace: true });
  },
});
